exports.applicationStatuses = {
  CREATED: 0,
  ACCEPTED: 1,
  FINISHED: 2,
  CANCELED: 3,
  REJECTED: 4,
};

exports.applicationClientFlag = {
  DEFAULT: 0,
  STARRED: 1,
  HIDDEN: 2,
};

exports.taskStatuses = {
  CREATED: 0,
  FILLED: 1,
  ACCEPTING: 2,
  CLOSED: 9,
};

exports.roleNames = {
  FREELANCER: 'freelancer',
  CLIENT: 'client',
  ADMINISTRATOR: 'administrator',
  AGENT: 'agent',
};

exports.roles = {
  FREELANCER: 1,
  CLIENT: 2,
  ADMINISTRATOR: 3,
  AGENT: 4,
};

exports.saltRounds = 10;

exports.escrowStatuses = {
  NO_ESCROW: 0, // no escrow on task
  ESCROW_PENDING: 1, // escrow is pending for client funds
  ESCROW_SET: 2, // escrow is set and funded
  ESCROW_PAYMENT: 3, // task is done and waiting for payment to freelancer
  ESCROW_PAID: 4, // escrow is paid to freelancer
  ESCROW_WITHDRAWAL: 5, // escrow is set for withdrawal
  ESCROW_WITHDRAWN: 6, // escrow has been withdrawn
  ESCROW_DISPUTE_CLIENT: 7, // client set escrow to dispute
  ESCROW_DISPUTE_FREELANCER: 8, // freelancer set escrow to dispute
};

exports.escrowMinBalance = 5;

// maximum number of attempts to check if crypto payment has been made
exports.maxCryptoVisibilityChecks = 120;

exports.subscriptionStatuses = {
  CREATED: 0,
  PAYMENT: 1,
  ACTIVE: 2,
  EXPIRED: 3,
  DISABLED: 9,
};

exports.paymentTypes = {
  PAYMENT: 0,
  RETURN: 1,
};

exports.paymentStatuses = {
  CREATED: 0,
  PROCESSING: 1,
  PENDING: 2,
  PAID: 3,
  PARTIAL: 4,
  FAILED: 9,
};

exports.packageNames = {
  BASIC_TASK: 'basicTaskVisibility',
  BASIC_FREELANCER: 'basicFreelancerVisibility',
};

exports.taskTypes = {
  FULLTIME: 'fulltime',
  PARTTIME: 'parttime',
  ONETIME: 'onetime'
};

exports.taskLocations = {
  ONSITE: 'onsite',
  REMOTE: 'remote',
  HYBRID: 'hybrid'
};

exports.taskPriceTypes = {
  HOURLY: 'hourly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  MILESTONES: 'milestones',
  FIXED: 'fixed'
};

exports.limits = {
  INVITATIONS_LIMIT: 5,
  AGENT_INVITATIONS_LIMIT: 5,
  MATCHING_EMAILS_LIMIT: 100,
  AGENT_RECOMMENDATIONS_LIMIT: 10
};

exports.invitationStatuses = {
  CREATED: 'created',
  ACCEPTED: 'accepted'
};

exports.tasksSortOptions = {
  DATE_ADDED: 'timePosted',
  PRICE: 'price'
};